import React from "react";
import {Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography,} from "@mui/material";

const quartileMapping = {
    A: {color: "#03AF9A", label: "Top Quartile"},
    B: {color: "#8269D2", label: "2nd Quartile"},
    C: {color: "#EBB941", label: "3rd Quartile"},
    D: {color: "#F05E63", label: "4th Quartile"},
    NA: {color: "#003C69", label: "Data Unavailable"},
};

const renderCircle = (value, isFirstRow = false) => {
    const {color} = quartileMapping[value] || quartileMapping["NA"];
    return (
        <Box
            sx={{
                width: isFirstRow ? 30 : 22,
                height: isFirstRow ? 30 : 22,
                borderRadius: "50%",
                backgroundColor: color,
                display: "inline-block",
            }}
        />
    );
};

const CPCITable = ({cpciTableData, country}) => (
    <TableContainer
        component={Paper}
        sx={{
            width:{xs:'100%',sm: undefined},
            border: "1px solid #295F93",
            borderRadius: "0px",
            borderBottomLeftRadius: "0",
            borderBottomRightRadius: "0",
            padding: {xs: '0px', sm: '0 35px'},
        }}
    >
        <Table  sx={{tableLayout:{xs:'fixed', sm:'auto'}}}>
            <TableHead>
                <TableRow>
                    <TableCell
                        sx={{
                            backgroundColor: "#ffffff",
                            textAlign: "center",
                            fontWeight: "bold",
                            color: "#5F6162",
                            borderBottom: "1px solid #ddd",
                            borderLeft: "none",
                            borderRight: "none",
                        }}
                    >
                        Summary
                    </TableCell>
                    <TableCell
                        sx={{
                            backgroundColor: "#ffffff",
                            textAlign: "center",
                            fontWeight: "bold",
                            color: "#295F93",
                            borderBottom: "1px solid #ddd",
                            borderLeft: "none",
                            borderRight: "none",
                        }}
                    >
                        {country?.toUpperCase()}
                    </TableCell>
                    <TableCell
                        sx={{
                            backgroundColor: "#ffffff",
                            textAlign: "center",
                            fontWeight: "bold",
                            color: "#295F93",
                            borderBottom: "1px solid #ddd",
                            borderLeft: "none",
                            borderRight: "none",
                        }}
                    >
                        GLOBAL
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {cpciTableData.map((row, index) => (
                    <TableRow
                        key={index}
                        sx={{
                            borderBottom: "1px solid #ddd",
                            "&:last-child": {borderBottom: "none"},
                        }}
                    >
                        <TableCell
                            sx={{
                                paddingX: "16px",
                                paddingY: "0px",
                                borderRight: "none",
                            }}
                        >
                            <Typography
                                sx={{
                                    color:'#003C69',
                                    fontSize: {
                                        xs: index === 0 ? "18px !important" : "14px",
                                        sm: index === 0 ? "32px !important" : "16px",
                                        md: index === 0 ? "16px !important" : "16px"
                                    },
                                    fontWeight: "bold",
                                    borderLeft: "none",
                                }}
                            >
                                {row.summary}
                            </Typography>
                        </TableCell>
                        <TableCell
                            sx={{
                                textAlign: "center",
                                borderLeft: "none",
                                borderRight: "none",
                                paddingTop: "11px",
                                paddingBottom: "6px",
                            }}
                        >
                            {renderCircle(row.country, index === 0)}
                        </TableCell>
                        <TableCell
                            sx={{
                                textAlign: "center",
                                borderLeft: "none",
                                borderRight: "none",
                                paddingTop: "11px",
                                paddingBottom: "6px",
                            }}
                        >
                            {renderCircle(row.global, index === 0)}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
);

export default CPCITable;
